import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from "./logo.png";
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt
        glareEnable={true}
        glareMaxOpacity={0.25}
        scale={1.05}
        tiltMaxAngleX={10}
        tiltMaxAngleY={10}
      >
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          {/* Front Side */}
          <div className="card-face card-front p-4">
            {/* Company Name */}
            <div className="company-header text-center">
              <h5 className="brand-title mb-2">Shri Guru Nanak Electricals Pvt. Ltd.</h5>
              <div className="brand-divider"></div>
            </div>

            {/* Center Logo */}
            <div className="logo-wrapper">
              <div className="logo-circle big">
                <img src={logo} alt="Company Logo" />
              </div>
            </div>

            {/* User Info */}
            <div className="user-info text-center mt-3">
              <h5 className="card-name mb-1">Mr. Rajinder Singh Rooprai</h5>
              {/* <p className="card-role mb-1">Owner</p> */}
              <p className="card-phone mb-2">+91-9810076381</p>
              <p className="card-phone mb-2">+011-25413041</p>
              <p className="card-phone mb-2">+011-45656381</p>

            </div>

            {/* QR + Contact */}
            <div className="qr-section d-flex justify-content-between align-items-end">
              <div className="small-details">
                <p className=" mb-1"> <i className="fa fa-envelope  me-2"></i>newgoldgurunanak@gmail.com</p>
                <p className=" mb-2"><i className="fa fa-globe me-2"></i>newgold.in</p>
              </div>

              <QRCodeSVG
                value={`BEGIN:VCARD
VERSION:3.0
N:Mr. Rajinder Singh Rooprai
TEL:+919810460840
EMAIL:newgoldgurunanak@gmail.com
END:VCARD`}
                size={60}
                fgColor="#000"
              />
            </div>
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
           <div className="company-header text-center">
              <h5 className="brand-title mb-2">Shri Guru Nanak Electricals Pvt. Ltd.</h5>
              <div className="brand-divider"></div>
            </div>

            {/* Center Logo */}
            {/* <div className="logo-wrapper">
              <div className="logo-circle big">
                <img src={logo} alt="Company Logo" />
              </div>
            </div> */}

            <p className="address text-start large text-muted">
              <h5 className="text-center text-dark">Contact Details:</h5>
              <div className="brand-divider "></div>
              <div className="pt-2">
                {" "}
                <i className="fa fa-map me-2"></i>17, DLF Industrial Area, Moti Nagar, New Delhi 110015
                <p className=" mb-1"><i className="fa fa-envelope  me-2"></i>  newgoldgurunanak@gmail.com</p>
                <p className=" mb-2"> <i className="fa fa-globe me-2"></i> Website: newgold.in</p>
              </div>
            </p>
            <div className="qr-box " style={{top:'30%'}}>
              <QRCodeSVG
                value="https://maps.app.goo.gl/NAc1Y9Cv9j6dVcpV7"
                size={100}
                fgColor="#000000" 
              />
            </div>
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div
        className="d-flex flex-column gap-3 mt-5 w-75 mx-auto"
        style={{ maxWidth: "280px" }}
      >
        <a href="/Rajinder.vcf" download className="platinum-btn">
          Add To Contacts
        </a>
        <a href="tel:+919810460840" className="platinum-btn">
          Call Now
        </a>
        <a href="mailto:newgoldgurunanak@gmail.com" className="platinum-btn">
          Email Us
        </a>
        <a
          href="https://wa.me/+919810460840"
          target="_blank"
          className="platinum-btn"
        >
          WhatsApp
        </a>

        <a
          href="https://newgold.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Website
        </a>
        <a
          href="https://maps.app.goo.gl/NAc1Y9Cv9j6dVcpV7"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Address Details
        </a>
        {/* <a href="/brochure.pdf" download className="platinum-btn">
          Brochure
        </a> */}
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
